import React, { useState, useEffect } from 'react';
import adminService from '../../services/adminService';
import styles from './AdminBannersPage.module.scss';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import { IoTrash, IoAdd, IoPencil, IoImageOutline, IoClose, IoRefreshOutline, IoSaveOutline, IoEyeOutline, IoLinkOutline } from 'react-icons/io5';
import { toast } from 'react-toastify';
import MediaLibraryModal from '../../components/common/MediaLibraryModal/MediaLibraryModal';

const BACKEND_URL = 'https://huongtramcomoc.vn';

const AdminBannersPage = () => {
  const [banners, setBanners] = useState([]); 
  const [loading, setLoading] = useState(true);
  
  // FORM STATE
  const [id, setId] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [linkUrl, setLinkUrl] = useState('');
  const [displayOrder, setDisplayOrder] = useState(0);
  const [isActive, setIsActive] = useState(1);
  
  // EDIT STATE
  const [isEditing, setIsEditing] = useState(false);
  const [originalId, setOriginalId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    loadBanners();
  }, []);

  const loadBanners = () => {
    setLoading(true);
    adminService.getBanners()
      .then(response => {
        // KIỂM TRA DỮ LIỆU TRẢ VỀ CÓ PHẢI MẢNG KHÔNG
        if (Array.isArray(response.data)) {
            setBanners(response.data);
        } else {
            // Nếu API trả về object hoặc null, set về mảng rỗng để không lỗi
            setBanners([]); 
            console.warn("API không trả về mảng:", response.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setBanners([]); // Lỗi thì cũng set rỗng
        setLoading(false);
      });
  };

  const handleGenerateId = () => {
    setId("BN" + Math.floor(Math.random() * 10000).toString().padStart(4, '0'));
  };

  const handleFileSelect = (file) => {
    // Khi chọn file, lưu đường dẫn vào state
    setImageUrl(file.file_path);
  };

  const handleEdit = (banner) => {
    setIsEditing(true);
    setOriginalId(banner.id);
    setId(banner.id);
    setTitle(banner.title);
    setDescription(banner.description);
    setImageUrl(banner.image_url);
    setLinkUrl(banner.link_url);
    setDisplayOrder(banner.display_order);
    setIsActive(banner.is_active);
    
    const formEl = document.getElementById('banner-form');
    if(formEl) formEl.scrollIntoView({ behavior: 'smooth' });
  };

  const resetForm = () => {
    setIsEditing(false);
    setOriginalId('');
    setId('');
    setTitle('');
    setDescription('');
    setImageUrl('');
    setLinkUrl('');
    setDisplayOrder(0);
    setIsActive(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!id || !title || !imageUrl) {
        toast.warning("Vui lòng nhập ID, Tiêu đề và chọn Ảnh.");
        return;
    }

    const data = { id, title, description, image_url: imageUrl, link_url: linkUrl, display_order: displayOrder, is_active: isActive };

    try {
      if (isEditing) {
        await adminService.updateBanner({ ...data, old_id: originalId });
        toast.success('Cập nhật thành công!');
      } else {
        await adminService.createBanner(data);
        toast.success('Thêm banner thành công!');
      }
      resetForm();
      loadBanners();
    } catch (err) {
      toast.error('Lỗi: ' + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = (bannerId) => {
    if (window.confirm("Bạn chắc chắn muốn xóa banner này?")) {
      adminService.deleteBanner(bannerId)
        .then(() => { toast.success('Đã xóa.'); loadBanners(); })
        .catch(err => toast.error('Lỗi xóa.'));
    }
  };

  // --- HÀM HỖ TRỢ HIỂN THỊ ẢNH ---
  const getFullImageUrl = (path) => {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return `${BACKEND_URL}${path}`;
  };

  return (
    <div className={commonStyles.adminPage}>
      <h1>Quản Lý Banner Trang Chủ</h1>

      <div className={styles.layoutContainer}>
        
        {/* CỘT TRÁI: FORM */}
        <div className={styles.formColumn} id="banner-form">
            <div className={styles.formCard}>
                <div className={styles.cardHeader}>
                    <h3>{isEditing ? `Sửa Banner` : 'Thêm Banner Mới'}</h3>
                    {isEditing && <button onClick={resetForm} className={styles.cancelBtn}><IoClose /></button>}
                </div>

                <form onSubmit={handleSubmit}>
                    {/* ID */}
                    <div className={styles.formGroup}>
                        <label>Mã Banner (ID)</label>
                        <div className={styles.inputGroupWithBtn}>
                            <input type="text" value={id} onChange={(e) => setId(e.target.value)} placeholder="VD: BN001" className={styles.inputControl} />
                            {!isEditing && <button type="button" onClick={handleGenerateId} className={styles.iconBtn}><IoRefreshOutline /></button>}
                        </div>
                    </div>

                    {/* CONTENT */}
                    <div className={styles.formGroup}>
                        <label>Tiêu đề chính</label>
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="VD: Tinh Hoa Đất Trời" className={styles.inputControl} />
                    </div>
                    
                    <div className={styles.formGroup}>
                        <label>Mô tả phụ</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="VD: Khám phá bộ sưu tập..." className={styles.inputControl} rows="2"></textarea>
                    </div>

                    <div className={styles.row2}>
                        <div className={styles.formGroup}>
                            <label>Link nút bấm</label>
                            <div className={styles.iconInput}>
                                <IoLinkOutline />
                                <input type="text" value={linkUrl} onChange={(e) => setLinkUrl(e.target.value)} placeholder="/san-pham" />
                            </div>
                        </div>
                        <div className={styles.formGroup}>
                            <label>Thứ tự</label>
                            <input type="number" value={displayOrder} onChange={(e) => setDisplayOrder(e.target.value)} className={styles.inputControl} />
                        </div>
                    </div>

                    <div className={styles.formGroup}>
                        <label>Hình nền Banner</label>
                        <div className={styles.imagePicker} onClick={() => setIsModalOpen(true)}>
                            {imageUrl ? (
                                <img src={getFullImageUrl(imageUrl)} alt="Preview" className={styles.pickedImg} />
                            ) : (
                                <div className={styles.placeholder}><IoImageOutline /> Chọn ảnh banner</div>
                            )}
                        </div>
                    </div>
                    
                    <div className={styles.checkboxGroup}>
                        <input type="checkbox" id="isActive" checked={isActive == 1} onChange={(e) => setIsActive(e.target.checked ? 1 : 0)} />
                        <label htmlFor="isActive">Hiển thị ngay</label>
                    </div>

                    <button type="submit" className={styles.submitBtn}>
                        {isEditing ? <IoSaveOutline /> : <IoAdd />} {isEditing ? 'Lưu Thay Đổi' : 'Thêm Banner'}
                    </button>
                </form>
            </div>

            {/* PREVIEW CARD - ĐÃ SỬA LỖI HIỂN THỊ */}
            <div className={styles.previewCard}>
                <h4><IoEyeOutline /> Xem trước hiển thị</h4>
                {(() => {
                    const previewBg = imageUrl ? `url('${getFullImageUrl(imageUrl)}')` : 'none';
                    return (
                        <div 
                            className={styles.bannerPreview} 
                            style={{ 
                                backgroundImage: previewBg,
                                backgroundSize: 'cover',   // Đảm bảo ảnh phủ kín
                                backgroundPosition: 'center' // Căn giữa ảnh
                            }}
                        >
                            <div className={styles.overlay}></div>
                            <div className={styles.content}>
                                <h2>{title || 'Tiêu đề Banner'}</h2>
                                <p>{description || 'Mô tả ngắn về chương trình...'}</p>
                                <button className={styles.fakeBtn}>KHÁM PHÁ NGAY</button>
                            </div>
                        </div>
                    );
                })()}
            </div>
        </div>

        {/* CỘT PHẢI: DANH SÁCH */}
        <div className={styles.listColumn}>
            <div className={styles.listCard}>
                <h3>Danh sách Banner ({banners.length})</h3>
                <div className={styles.tableResponsive}>
                    <table className={styles.customTable}>
                        <thead>
                            <tr>
                                <th width="80">Ảnh</th>
                                <th>Nội dung</th>
                                <th width="50">TT</th>
                                <th width="50">TT</th>
                                <th width="80">#</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* KIỂM TRA MẢNG AN TOÀN */}
                            {Array.isArray(banners) && banners.length > 0 ? (
                                banners.map(bn => (
                                    <tr key={bn.id} className={originalId === bn.id ? styles.activeRow : ''}>
                                        <td>
                                            <div className={styles.imgCell}>
                                                <img src={getFullImageUrl(bn.image_url)} alt="" />
                                            </div>
                                        </td>
                                        <td>
                                            <div className={styles.infoCell}>
                                                <strong>{bn.title}</strong>
                                                <small>{bn.description}</small>
                                                <small className={styles.linkText}>Link: {bn.link_url || '#'}</small>
                                            </div>
                                        </td>
                                        <td className="text-center">{bn.display_order}</td>
                                        <td className="text-center">
                                            <span className={bn.is_active == 1 ? styles.badgeActive : styles.badgeInactive}>
                                                {bn.is_active == 1 ? 'Bật' : 'Tắt'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className={styles.actionCell}>
                                                <button onClick={() => handleEdit(bn)} className={styles.btnEdit}><IoPencil /></button>
                                                <button onClick={() => handleDelete(bn.id)} className={styles.btnDel}><IoTrash /></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center" style={{padding: '20px'}}>
                                        {loading ? "Đang tải dữ liệu..." : "Chưa có banner nào."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>

      <MediaLibraryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onFileSelect={handleFileSelect}
      />
    </div>
  );
};

export default AdminBannersPage;